export enum VerticalAlign {
  BASELINE = 'baseline',
  CENTER = ' enter',
}

export enum TextLinkAppearance {
  RICHTEXT,
}
